import { map } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Observable } from 'rxjs';

@Injectable()
export class InvoicePdfCommandHandler implements ICommandHandler {
  constructor(
    private _service: InvoiceService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command.id !== invoiceCommand.getpdf) {
      return false;
    }
    if (command instanceof Command) {
      return command.context;
    }
    if (command instanceof MultiselectCommand) {
      return command.items.length > 0;
    }

    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this.executeForSingleInvoice(command.context.id);
    }

    if (command instanceof FilteredCommand) {
      return this._service
        .OrderPdfPrintForFilter(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(
          map(res => {
            return true;
          })
        );
    }

    if (command instanceof MultiselectCommand) {
      return this._service.OrderPdfPrint(command.items.map(item => item.id)).pipe(
        map(res => {
          return true;
        })
      );
    }
  }

  private executeForSingleInvoice(itemId: string): Observable<boolean> {
    const tab = this._nativeWindow.openTab();
    return this._service.getPdf(itemId).pipe(
      map(res => this._nativeWindow.openFile(res, `${itemId}.pdf`, tab)),
      map(x => true)
    );
  }
}
